import {KeyframeEditorController} from './editor/KeyframeEditor';
import {PolyScene} from '../../../../@polygonjs/polygonjs/src/engine/scene/PolyScene';

import {BaseNodeType} from '../../../../@polygonjs/polygonjs/src/engine/nodes/_Base.js';
import {StoreController} from './StoreController';

import {EditorClipboardStoreController} from './editor/EditorClipboardStoreController';
import {EditorContextMenuStoreController} from './editor/EditorContextMenuStoreController';
import {EditorDialogAboutStoreController} from './editor/EditorDialogAboutStoreController';
import {EditorDialogWarningsStoreController} from './editor/EditorDialogWarningsStoreController';
import {EditorDialogConfirmStoreController} from './editor/EditorDialogConfirmStoreController';
// import {EditorDialogDesktopLoginStoreController} from './editor/EditorDialogDesktopLoginStoreController';
import {EditorDialogPromptStoreController} from './editor/EditorDialogPromptStoreController';
import {EditorDialogNoticeStoreController} from './editor/EditorDialogNoticeStoreController';
import {EditorDialogApiLoginStoreController} from './editor/EditorDialogApiLoginStoreController';
// import {EditorDialogApiExportStoreController} from './editor/EditorDialogApiExportStoreController';
import {EditorDialogWebGLCapabilitiesStoreController} from './editor/EditorDialogWebGLCapabilitiesStoreController';
import {MarketplacePolyNodesController} from './editor/MarketplacePolyNodes';

import {EditorUserPlanStoreController} from './editor/EditorUserPlan';

// import {EditorDialogNewProjectStoreController} from './editor/EditorDialogNewProjectStoreController';
import {EditorNetworkStoreController} from './editor/EditorNetworkStoreController';
import {EditorNumericSliderStoreController} from './editor/EditorNumericSliderStoreController';
import {EditorPanelStoreController} from './editor/EditorPanelStoreController';
import {EditorPanelNodeSelectorStoreController} from './editor/EditorPanelNodeSelectorController';
import {EditorPanelFileSelectorStoreController} from './editor/EditorPanelFileSelectorController';
import {EditorPanelObjectMaskStoreController} from './editor/EditorPanelObjectMaskController';
import {EditorPanelSpareParamsEditorStoreController} from './editor/EditorPanelSpareParamsEditorController';
import {EditorPanelSceneSelectorStoreController} from './editor/EditorPanelSceneSelectorController';
import {EditorParamsModalsController} from './editor/EditorParamsModalsController';
import {EditorWindowsLibrariesManagerController} from './editor/EditorWindowsLibrariesManagerController';
import {EditorStatusStoreController} from './editor/EditorStatusStoreController';
import {EditorUploadsStoreController} from './editor/EditorUploadsStoreController';
import {EditorCurrentUserController} from './editor/EditorCurrentUserController';
import {EditorPolyNodeCreateFormController} from './editor/EditorPolyNodeCreateFormController';
import {EditorPolyNodeUpdateFormController} from './editor/EditorPolyNodeUpdateFormController';

import {EditorNodeInfoStoreController} from './editor/EditorNodeInfoStoreController';

import {SplitPanels} from './editor/SplitPanels';
import {CaptureForm} from './editor/CaptureForm';
import {CaptureResult} from './editor/CaptureResult';
import {ExportFormWeb} from './editor/ExportFormWeb';
import {ExportFormLocal} from './editor/ExportFormLocal';
import {EditorPanelAssetsListStoreController} from './editor/EditorPanelAssetsList';
import {SaveOptions} from './editor/SaveOptions';
import {SaveWarnings} from './editor/SaveWarnings';

import {EngineNodeData} from '../modules/Engine';
import {CoreGraphNodeId} from '../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {ref, Ref} from 'vue';
import {LinkIndex} from '../../components/panels/common/LinkIndex';
import {NavigationHistoryStoreController} from './editor/NavigationHistoryController';
import {NavigationNodeListController} from './editor/NavigationNodeListController';

interface CurrentNodeIdByLinkIndex {
	1: CoreGraphNodeId;
	2: CoreGraphNodeId;
	3: CoreGraphNodeId;
	4: CoreGraphNodeId;
	5: CoreGraphNodeId;
	6: CoreGraphNodeId;
	7: CoreGraphNodeId;
	8: CoreGraphNodeId;
}

interface SetCurrentNodeOptions {
	pushToHistory: boolean;
}
export class EditorStoreControllerClass {
	// private _store!: Store<State>;
	private _scene!: PolyScene;

	private _currentNodeId!: Ref<CurrentNodeIdByLinkIndex>;
	// private _rootSelected!: Ref<boolean>;

	public readonly clipboard = EditorClipboardStoreController;
	public readonly contextMenu = EditorContextMenuStoreController;
	public readonly dialogAbout = EditorDialogAboutStoreController;
	public readonly dialogWarnings = EditorDialogWarningsStoreController;
	public readonly dialog_confirm = EditorDialogConfirmStoreController;
	// public readonly dialog_desktop_login = EditorDialogDesktopLoginStoreController;
	public readonly dialogPrompt = EditorDialogPromptStoreController;
	public readonly dialogNotice = EditorDialogNoticeStoreController;
	public readonly dialogApiLogin = EditorDialogApiLoginStoreController;
	// public readonly dialog_api_export = EditorDialogApiExportStoreController;
	public readonly dialogWebGLCapabilities = EditorDialogWebGLCapabilitiesStoreController;
	// public readonly dialog_new_project = EditorDialogNewProjectStoreController;
	public readonly keyframeEditor = KeyframeEditorController;
	public readonly network = EditorNetworkStoreController;
	public readonly numericSlider = EditorNumericSliderStoreController;
	public readonly panel = EditorPanelStoreController;
	public readonly panelNodeSelector = EditorPanelNodeSelectorStoreController;
	public readonly panelFileSelector = EditorPanelFileSelectorStoreController;
	public readonly panelObjectMask = EditorPanelObjectMaskStoreController;
	public readonly panelSpareParams = EditorPanelSpareParamsEditorStoreController;
	public readonly panelSceneSelector = EditorPanelSceneSelectorStoreController;
	public readonly paramsModals = EditorParamsModalsController;
	public readonly windowsLibrariesManager = EditorWindowsLibrariesManagerController;
	public readonly status = EditorStatusStoreController;
	public readonly uploads = EditorUploadsStoreController;
	public readonly user_plan = EditorUserPlanStoreController;
	public readonly nodeInfo = EditorNodeInfoStoreController;
	public readonly navigationHistory = NavigationHistoryStoreController;
	public readonly navigationNodeList = NavigationNodeListController;
	public readonly splitPanels = SplitPanels;
	public readonly captureForm = CaptureForm;
	public readonly captureResult = CaptureResult;
	public readonly exportFormWeb = ExportFormWeb;
	public readonly exportFormLocal = ExportFormLocal;
	public readonly panelAssetsList = EditorPanelAssetsListStoreController;
	public readonly saveOptions = SaveOptions;
	public readonly saveWarnings = SaveWarnings;
	public readonly currentUser = EditorCurrentUserController;
	public readonly polyNodeCreateForm = EditorPolyNodeCreateFormController;
	public readonly polyNodeUpdateForm = EditorPolyNodeUpdateFormController;
	public readonly marketplacePolyNodes = MarketplacePolyNodesController;

	private static _instance: EditorStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorStoreControllerClass());
	}

	private constructor() {}
	set_scene(scene: PolyScene) {
		this._scene = scene;
		this.init();
	}
	get scene() {
		return this._scene;
	}
	// set_store() {
	// 	// this._store = store;
	// 	// this.clipboard.set_store(store);
	// 	// this.contextMenu.init();
	// 	// this.dialog_alert.init();
	// 	// this.dialog_confirm.set_store(store);
	// 	// this.dialog_desktop_login.set_store(store);
	// 	// this.dialogNotice.init();
	// 	// this.dialog_api_login.init();
	// 	// this.dialog_api_export.init();
	// 	// this.dialogWebGLCapabilities.init();
	// 	// this.dialog_new_project.set_store(store);
	// 	// this.network.set_store(store);
	// 	// this.numeric_slider.set_store(store);
	// 	// this.panel.set_store(store);
	// 	// this.panelNodeSelector.init();
	// 	// this.panelFileSelector.init();
	// 	// this.panelObjectMask.init();
	// 	// this.panelSpareParams.init();
	// 	// this.panelSceneSelector.init();
	// 	// this.paramsModals.init();
	// 	// this.status.init();
	// 	// this.uploads.set_store(store);
	// 	// this.user_plan.init();
	// 	// this.nodeInfo.init();
	// 	// this.navigationHistory.init();
	// 	// this.navigationNodeList.init();
	// 	// this.splitPanels.init();
	// 	// this.captureResult.init();
	// 	// this.exportFormWeb.init();
	// 	// this.exportFormLocal.init();
	// 	// this.panelAssetsList.init();
	// 	// this.saveOptions.init();
	// 	// this.saveWarnings.init();
	// 	// this.currentUser.init();
	// 	// this.polyNodeCreateForm.init();
	// 	// this.polyNodeUpdateForm.init();
	// }
	private init() {
		const rootId = this.scene.root().graphNodeId();
		this._currentNodeId = ref({
			1: rootId,
			2: rootId,
			3: rootId,
			4: rootId,
			5: rootId,
			6: rootId,
			7: rootId,
			8: rootId,
		});

		// this._rootSelected = ref(false);
	}
	reset() {
		this.navigationHistory.reset();
	}

	closeAllPopups() {
		this.removeContextMenus();
		// this.dialog_alert.hide()
		// this.dialog_confirm.hide()
		// this.dialog_prompt.hide()
		this.numericSlider.close();
		this.panelNodeSelector.close();
		this.panelFileSelector.close();
		this.windowsLibrariesManager.close();
	}
	removeContextMenus() {
		this.contextMenu.setNodeId(null);
		this.contextMenu.setParamId(null);
		this.navigationNodeList.close();
	}

	// getters
	current_node_graph_id(linkIndex: LinkIndex): CoreGraphNodeId {
		return this._currentNodeId.value[linkIndex];
		// return this._store.getters['editor/current_node_id'];
	}
	// rootSelected(): boolean {
	// 	return this._rootSelected.value;
	// 	// return this._store.getters['editor/current_node_id'];
	// }
	current_json_node(linkIndex: LinkIndex): EngineNodeData | null {
		const id = this.current_node_graph_id(linkIndex);
		if (id) {
			return StoreController.engine.json_node(id);
		} else {
			return null;
		}
	}
	currentNode(linkIndex: LinkIndex): BaseNodeType {
		const id = this.current_node_graph_id(linkIndex);
		if (id) {
			const node = this._scene.graph.nodeFromId(id);
			if (node) {
				return node as BaseNodeType;
			}
		}
		return StoreController.scene.root();
	}

	// mutations
	setCurrentNode(linkIndex: LinkIndex, node: BaseNodeType, options?: SetCurrentNodeOptions) {
		let pushToHistory = true;
		if (options) {
			pushToHistory = options.pushToHistory;
		}
		const nodeId = node.graphNodeId();
		this._currentNodeId.value[linkIndex] = nodeId;
		if (pushToHistory) {
			this.navigationHistory.pushCurrentNode(linkIndex, node);
		}
	}
	// selectRoot() {
	// 	this.paramsModals.add(this.scene.root());
	// 	// this._rootSelected.value = true;
	// }
	// deselectRoot() {
	// 	this._rootSelected.value = false;
	// }
	goUp(linkIndex: LinkIndex) {
		const parent = this.currentNode(linkIndex).parent();
		if (parent) {
			this.setCurrentNode(linkIndex, parent);
		}
	}
	goDown(linkIndex: LinkIndex) {
		const node = this.currentNode(linkIndex);
		if (node.childrenAllowed() && node.childrenController) {
			const child_node = node.childrenController.selection.nodes()[0];
			if (child_node && child_node.childrenAllowed()) {
				this.setCurrentNode(linkIndex, child_node);
			}
		}
	}
}

export const EditorStoreController = EditorStoreControllerClass.instance();
